import {Component, OnInit} from '@angular/core';

import {StreamService} from '../shared/services/stream_service';
import {UserService} from '../shared/services/user_service';

import { Stream } from '../shared/types/stream';

@Component({
  selector: 'creator-call-to-action',
  templateUrl: './creator-call-to-action.component.html',
  styleUrls: ['./creator-call-to-action.component.scss']
})

export class CreatorCallToActionComponent implements OnInit {
  public display = true;
  public userStreams: Stream[] = [];
  public isLoggedIn: boolean;

  constructor(
    private userService: UserService,
    private streamService: StreamService
  ) {}

  public ngOnInit(): void {
    this.isLoggedIn = this.userService.isLoggedIn();
    if (this.isLoggedIn) {
      this.getUserStreams();
    }
  }

  private getUserStreams() {
    Promise.all([
      this.streamService.getUserStreams(),
      this.streamService.getUserTeamStreams()
    ]).then(results => {
      const userStreams = results[0];
      const userTeamStreams = results[1].channels ? results[1].channels : [];

      this.userStreams = this.updateUserStreamsWithTeamStream(userStreams, userTeamStreams);

      if (this.userStreams.length) {
        // this.newNoteDisabled = false;
      }
    }, err => {
      console.error('Error while fetching user streams: ', err);
    });
  }

  private updateUserStreamsWithTeamStream(userStreams: Stream[], teamStreams: Stream[]): Stream[] {
    for (const ts of teamStreams) {
      if (!userStreams.filter(us => us.id === ts.id).length) {
        userStreams.push(ts);
      }
    }

    return userStreams;
  }
}
